/**
 * Builds an empty row for the grid.
 *
 * All cells start at their empty_value — defaults are not seeded into the row.
 * Defaults for any blank field are applied at the calculation layer via
 * effectiveValue (in getFormatControlledValue) and at the server layer via
 * FieldsMapDefaults.
 *
 * For text and date columns, empty_value is { value: "" } (object).
 * For single-select columns, empty_value is null.
 *
 * @param {Array} columns - array of column definition objects
 * @returns {Object} a new row keyed by column.field
 */
export const buildEmptyRow = (columns) => {
  const row = {};
  columns.forEach((column) => {
    row[column.field] = column.empty_value;
  });
  return row;
};
